import { render, staticRenderFns } from "./ShiftDetail.vue?vue&type=template&id=6c70cae7&scoped=true"
import script from "./ShiftDetail.vue?vue&type=script&lang=js"
export * from "./ShiftDetail.vue?vue&type=script&lang=js"
import style0 from "./ShiftDetail.vue?vue&type=style&index=0&id=6c70cae7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70cae7",
  null
  
)

export default component.exports